module.exports = __webpack_public_path__ + "static/img/zhuanjie.e7ca697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zhuanjie.png
// module id = xeC+
// module chunks = 24